import { RESERVED_FIELDS } from "views/Constants";
import isFilteredField from "views/logic/IsFilteredField";
const isReservedField = (fieldName) => RESERVED_FIELDS.includes(fieldName) || isFilteredField(fieldName);
export default isReservedField;
